import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = {
  key: 0,
  class: "text-center"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "form-row" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { for: "inputState" }, "Kampanj:", -1)
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "float-end" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h1", null, "Artiklar", -1)
const _hoisted_11 = { class: "table" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = {
  colspan: "4",
  class: "text-center"
}
const _hoisted_14 = { key: 1 }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("td", {
  colspan: "4",
  class: "text-center"
}, "Inga artiklar finns", -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { scope: "row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_messages = _resolveComponent("messages")!
  const _component_fa_icon = _resolveComponent("fa-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_messages, { ref: "errorHandler" }, null, 512)
    ]),
    _createElementVNode("div", null, [
      (_ctx.loadingCampaigns)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_fa_icon, {
              icon: "spinner",
              spin: ""
            })
          ]))
        : _createCommentVNode("", true),
      (!_ctx.loadingCampaigns)
        ? (_openBlock(), _createElementBlock("form", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _withDirectives(_createElementVNode("select", {
                  id: "inputState",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedCampaign) = $event)),
                  onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.reloadArticles()))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.campaigns, (c) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: c.id,
                      value: c
                    }, _toDisplayString(c.id) + ": " + _toDisplayString(c.name), 9, _hoisted_7))
                  }), 128))
                ], 544), [
                  [_vModelSelect, _ctx.selectedCampaign]
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("button", {
        class: "btn btn-lg btn-outline-secondary mt-1",
        disabled: _ctx.selectedCampaign == null,
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.fetchArticles(_ctx.selectedCampaign!.id)))
      }, [
        _createVNode(_component_fa_icon, { icon: "sync-alt" })
      ], 8, _hoisted_9)
    ]),
    _hoisted_10,
    _createElementVNode("table", _hoisted_11, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("th", {
            scope: "col",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.sort('productID'))),
            class: _normalizeClass(["sortable", {
            sorted: _ctx.sortBy === 'productID',
            reverse: _ctx.sortReverse,
          }])
          }, " # ", 2),
          _createElementVNode("th", {
            scope: "col",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.sort('name'))),
            class: _normalizeClass(["sortable", {
            sorted: _ctx.sortBy === 'name',
            reverse: _ctx.sortReverse,
          }])
          }, " Namn ", 2),
          _createElementVNode("th", {
            scope: "col",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.sort('campaignName'))),
            class: _normalizeClass(["sortable", {
            sorted: _ctx.sortBy === 'campaignName',
            reverse: _ctx.sortReverse,
          }])
          }, " Kampanj ", 2)
        ])
      ]),
      _createElementVNode("tbody", null, [
        (_ctx.loadingArticles)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_12, [
              _createElementVNode("td", _hoisted_13, [
                _createVNode(_component_fa_icon, {
                  icon: "spinner",
                  spin: ""
                })
              ])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.loadingArticles && _ctx.articles.length === 0)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_14, _hoisted_16))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.articles, (article) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: article.id
          }, [
            _createElementVNode("th", _hoisted_17, _toDisplayString(article.productID), 1),
            _createElementVNode("td", null, _toDisplayString(article.name), 1),
            _createElementVNode("td", null, _toDisplayString(article.campaign.name), 1)
          ]))
        }), 128))
      ])
    ])
  ], 64))
}